
import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';
import { TranslationBlueprint } from '@backstage/plugin-app-react';


export const scaffolderReactTranslations: any = TranslationBlueprint.make({
  name: 'scaffolder-react-pt-BR',

  params: {
    resource: createTranslationResource({
      ref: scaffolderReactTranslationRef,
      translations: {
      'pt-BR': () => import('./scaffolder-react-ptbr'),
      },
    }),
  },
});